import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getStatuses,
    getLanguages
} from "./UsageClient";
import {changeUsage} from "./usageSlice";
import {changeUsageSearch} from "./usageSearchSlice";
import {getPlatformNames, getServices, getTerritories, getUsageMarkets} from "../Platform/PlatformClient";
import {getLicensees} from "../License/LicenseClient";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function UsageSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const { register, handleSubmit, control, setValue, reset } = useForm();
    // const {register, handleSubmit} = useForm();
    const [platformNameDropdown, setPlatformNameDropdown] = useState([]);
    const [selectedPlatformName, setSelectedPlatformName] = useState('');
    const [platformServiceDropdown, setPlatformServiceDropdown] = useState([]);
    const [selectedPlatformService, setSelectedPlatformService] = useState('');
    const [usageMarketDropdown, setUsageMarketDropdown] = useState([]);
    const [selectedUsageMarket, setSelectedUsageMarket] = useState('');
    const [territoryDropdown, setTerritoryDropdown] = useState([]);
    const [selectedTerritory, setSelectedTerritory] = useState('');
    const [languageDropdown, setLanguageDropdown] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [statusDropdown, setStatusDropdown] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [licenseeDropdown, setLicenseeDropdown] = useState([]);
    const [selectedLicensee, setSelectedLicensee] = useState('');
    const setupsDropdown = ["","Has","None"];
    const [selectedParticipations, setSelectedParticipations] = useState('');
    const [selectedResiduals, setSelectedResiduals] = useState('');
    const [selectedRoyalties, setSelectedRoyalties] = useState('');
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [usageValue, setUsageValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [usages, setUsages] = useState([]);

    const handleClearClick = () => {
        setUsageValue("");

    };

    const handleClearUsageClick = () => {
        setUsageValue("");
    };

    const fetchPlatformNames = () =>
        getPlatformNames()

            .then(data => {
                console.log("Platform Names");
                console.log(data);
                console.log("Platform Names with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPlatformNameDropdown(data);
            })

    const fetchPlatformServices = () => {
        getServices()

            .then(data => {
                console.log("Platform Services");
                console.log(data);
                console.log("Platform Services with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPlatformServiceDropdown(data);
            })}


    const fetchUsageMarkets = () =>
        getUsageMarkets()

            .then(data => {
                console.log("UsageMarkets");
                console.log(data);
                console.log("Usage Markets with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setUsageMarketDropdown(data);
            })

    const fetchTerritories = () =>
        getTerritories()

            .then(data => {
                console.log("Territories");
                console.log(data);
                console.log("Territories with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setTerritoryDropdown(data);
            })

    const fetchLanguages = () =>
        getLanguages()

            .then(data => {
                console.log("Languages");
                console.log(data);
                console.log("Languages with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setLanguageDropdown(data);
            })

    const fetchStatuses = () =>
        getStatuses()

            .then(data => {
                console.log("Statuses");
                console.log(data);
                console.log("Statuses with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setStatusDropdown(data);
            })


    const fetchLicensees = () =>
        getLicensees()

            .then(data => {
                console.log("Licensees");
                console.log(data);
                console.log("Licensees with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setLicenseeDropdown(data);
            })

    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchPlatformNames();
        fetchPlatformServices();
        fetchUsageMarkets();
        fetchTerritories();
        fetchLanguages();
        fetchStatuses();
        fetchLicensees();
    }, []);


    function onSubmit(data) {
        console.log("here's my usage search data before I submit it ")
        console.log({data});
        dispatchData(changeUsageSearch({
            fileId: data.fileId,
            propertyId: data.propertyId,
            productName: data.productName,
            episodeName: data.episodeName,
            photoStartDateFrom: data.photoStartDateFrom,
            photoStartDateTo: data.photoStartDateTo,
            seriesExternalId: data.seriesExternalId,
            seriesName: data.seriesName,
            seasonExternalId: data.seasonExternalId,
            seasonNumberFrom: data.seasonNumberFrom,
            seasonNumberTo: data.seasonNumberTo,
            seasonName: data.seasonName,
            platformId: data.platformId,
            platformName: data.platformName,
            service: data.service,
            usageMarket: data.usageMarket,
            territory: data.territory,
            licenseId: data.licenseId,
            licensee: data.licensee,
            useStartFrom: data.useStartFrom,
            useStartTo: data.useStartTo,
            useEndFrom: data.useEndFrom,
            useEndTo: data.useEndTo,
            language: data.language,
            id: data.id,
            externalId: data.externalId,
            stakeholderId: data.stakeholderId,
            status: data.status,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeUsage({
            usageGridRefresh: true
        }));
    };


    const handleClear = () => {

        reset({
            fileId: '',
            propertyId:  '',
            productName:  '',
            episodeName:  '',
            photoStartDateFrom:  '',
            photoStartDateTo:  '',
            seriesExternalId:  '',
            seriesName:  '',
            seasonExternalId:  '',
            seasonNumberFrom:  '',
            seasonNumberTo:  '',
            seasonName:  '',
            platformId:  '',
            platformName:  '',
            service:  '',
            usageMarket:  '',
            territory:  '',
            licenseId:  '',
            licensee:  '',
            useStartFrom:  '',
            useStartTo:  '',
            useEndFrom:  '',
            useEndTo:  '',
            language:  '',
            id:  '',
            externalId:  '',
            stakeholderId:  '',
            status:  '',
            participations:  '',
            residuals:  '',
            royalties: ''
        });

        setSelectedPlatformName('');
        setSelectedPlatformService('');
        setSelectedUsageMarket('');
        setSelectedTerritory('');
        setSelectedLicensee('');
        setSelectedLanguage('');
        setSelectedParticipations('');
        setSelectedResiduals('');
        setSelectedRoyalties('');
        setSelectedStatus('');

        gridClear()

    };

    const handlePlatformNameChange = (platformNameEvent) => {
        setSelectedPlatformName(platformNameEvent.target.value);
        console.log("This is for the selected Value");
        console.log(platformNameEvent.target.value);
    };

    const handlePlatformServiceChange = (platformServiceEvent) => {
        setSelectedPlatformService(platformServiceEvent.target.value);
        console.log("This is for the selected Value");
        console.log(platformServiceEvent.target.value);
    };

    const handleUsageMarketChange = (usageMarketEvent) => {
        setSelectedUsageMarket(usageMarketEvent.target.value);
        console.log("This is for the selected Value");
        console.log(usageMarketEvent.target.value);
    };
    const handleTerritoryChange = (territoryEvent) => {
        setSelectedTerritory(territoryEvent.target.value);
        console.log("This is for the selected Value");
        console.log(territoryEvent.target.value);
    };

    const handleLanguageChange = (languageEvent) => {
        setSelectedLanguage(languageEvent.target.value);
        console.log("This is for the selected Value");
        console.log(languageEvent.target.value);
    };

    const handleStatusChange = (statusEvent) => {
        setSelectedStatus(statusEvent.target.value);
        console.log("This is for the selected Value");
        console.log(statusEvent.target.value);
    };
    const handleLicenseeChange = (licenseeEvent) => {
        setSelectedLicensee(licenseeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(licenseeEvent.target.value);
    };

    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };
    const handleClearPlatformName = () => {
        setSelectedPlatformName("");}


    const selectR2mRef = useRef();

    const onClear = () => {
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 360, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('fileId', {required: false})}
                               id="fileId" name="fileId" label="File ID" aria-describedby="fileId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('propertyId', { required: false })}
                               id="propertyId"   name="propertyId"  label="Property ID" aria-describedby="propertyId_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('productName', { required: false })}
                               id="productName"   name="productName"  label="Product Name" aria-describedby="productName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('episodeName', { required: false })}
                               id="episodeName"   name="episodeName"  label="Episode Name" aria-describedby="episodeName_entry"
                               sx={{ width: 400 , pr: 5}} />
                    <FormDatePicker
                        name="photoStartDateFrom"
                        label="Photo From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="photoStartDateTo"
                        label="Photo To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateFrom', { required: false })}*/}
                    {/*           id="photoStartDateFrom"   name="photoStartDateFrom"  label="Photo From" aria-describedby="photoStartDateFrom_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateTo', { required: false })}*/}
                    {/*           id="photoStartDateTo"   name="photoStartDateTo"  label="Photo To" aria-describedby="photoStartDateTo_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('seriesExternalId', { required: false })}
                               id="seriesExternalId"   name="seriesExternalId"  label="Series ID" aria-describedby="seriesExternalId_entry"
                               sx={{ width:160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seriesName', { required: false })}
                               id="seriesName"   name="seriesName"  label="Series Name" aria-describedby="seriesName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonExternalId', { required: false })}
                               id="seasonExternalId"   name="seasonExternalId"  label="Season Id" aria-describedby="seasonExternalId_entry"
                               sx={{ width: 160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberFrom', { required: false })}
                               id="seasonNumberFrom"   name="seasonNumberFrom"  label="# From" aria-describedby="seasonNumberFrom_entry"
                               sx={{ width: 140, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberTo', { required: false })}
                               id="seasonNumberTo"   name="seasonNumberTo"  label="# To" aria-describedby="seasonNumberTo_entry"
                               sx={{ width: 140, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonName', { required: false })}
                               id="seasonName"   name="seasonName"  label="Season Name" aria-describedby="seasonName_entry"
                               sx={{ width: 400 }} />
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('platformId', { required: false })}
                               id="platformId"   name="platformId"  label="Platform ID" aria-describedby="platformId_entry"
                               sx={{ width: 150 }} />
                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="platformName">Platform Name</InputLabel>
                        <Select
                            {...register('platformName', { required: false })}
                            labelId="demo-simple-select-filled-platformName"
                            id="platformName"
                            FreeSolo={true}
                            variant="filled"
                            label="platformName"
                            value={selectedPlatformName}
                            onChange={handlePlatformNameChange}
                            sx={{ width: 300}}
                        >
                            {platformNameDropdown.map((platformNameItem) =>
                                <MenuItem  FreeSolo={true} value={platformNameItem.singleField} key={platformNameItem.singleField}
                                >{platformNameItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="service">Service</InputLabel>
                        <Select
                            {...register('service', { required: false })}
                            labelId="demo-simple-select-filled-platformId"
                            id="service"
                            FreeSolo={true}
                            variant="filled"

                            label="service"
                            value={selectedPlatformService}
                            onChange={handlePlatformServiceChange}
                            sx={{ width: 200}}
                        >
                            {platformServiceDropdown.map((platformServiceItem) =>
                                <MenuItem  FreeSolo={true} value={platformServiceItem.singleField} key={platformServiceItem.singleField}
                                >{platformServiceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="usageMarket">Usage Market</InputLabel>
                        <Select
                            {...register('usageMarket', { required: false })}
                            labelId="demo-simple-select-filled-usageMarket"
                            id="usageMarket"
                            FreeSolo={true}
                            variant="filled"
                            label="usageMarket"
                            value={selectedUsageMarket}
                            onChange={handleUsageMarketChange}
                            sx={{ width: 200}}
                        >
                            {usageMarketDropdown.map((usageMarketItem) =>
                                <MenuItem  FreeSolo={true} value={usageMarketItem.singleField} key={usageMarketItem.singleField}
                                >{usageMarketItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="territory">Territory</InputLabel>
                        <Select
                            {...register('territory', { required: false })}
                            labelId="demo-simple-select-filled-territory"
                            id="territory"
                            FreeSolo={true}
                            variant="filled"
                            label="territory"
                            value={selectedTerritory}
                            onChange={handleTerritoryChange}
                            sx={{ width: 200}}
                        >
                            {territoryDropdown.map((territoryItem) =>
                                <MenuItem  FreeSolo={true} value={territoryItem.singleField} key={territoryItem.singleField}
                                >{territoryItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <FormDatePicker
                        name="useStartFrom"
                        label="Use Start From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="useStartTo"
                        label="Use Start To"
                        control={control}
                        width={200}
                    />
                        <FormDatePicker
                            name="useEndFrom"
                            label="Use End From"
                            control={control}
                            width={200}
                        />
                        <FormDatePicker
                            name="useEndTo"
                            label="Use End To"
                            control={control}
                            width={200}
                        />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('useStartFrom', { required: false })}*/}
                    {/*           id="useStartFrom"   name="useStartFrom"  label="Use Start From" aria-describedby="useStartFrom_entry"*/}
                    {/*           sx={{ width: 180, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('useStartTo', { required: false })}*/}
                    {/*           id="useStartTo"   name="useStartTo"  label="Use Start To" aria-describedby="useStartTo_entry"*/}
                    {/*           sx={{ width: 180, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('useEndFrom', { required: false })}*/}
                    {/*           id="useEndFrom"   name="useEndFrom"  label="Use End From" aria-describedby="useEndFrom_entry"*/}
                    {/*           sx={{ width: 180, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('useEndTo', { required: false })}*/}
                    {/*           id="useEndTo"   name="useEndTo"  label="Use End To" aria-describedby="useEndTo_entry"*/}
                    {/*           sx={{ width: 180, pr: 5 }} />*/}
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="language">Language</InputLabel>
                        <Select
                            {...register('language', { required: false })}
                            labelId="demo-simple-select-filled-language"
                            id="language"
                            FreeSolo={true}
                            variant="filled"
                            label="language"
                            value={selectedLanguage}
                            onChange={handleLanguageChange}
                            sx={{ width: 200}}
                        >
                            {languageDropdown.map((languageItem) =>
                                <MenuItem  FreeSolo={true} value={languageItem.singleField} key={languageItem.singleField}
                                >{languageItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <TextField variant="filled"
                               {...register('licenseId', { required: false })}
                               id="licenseId"   name="licenseId"  label="License ID" aria-describedby="licenseIdentry"
                               sx={{ width: 150, pr: 5 }} />
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="licensee">Licensee</InputLabel>
                        <Select
                            {...register('licensee', { required: false })}
                            labelId="demo-simple-select-filled-licensee"
                            id="status"
                            FreeSolo={true}
                            variant="filled"
                            label="licensee"
                            value={selectedLicensee}
                            onChange={handleLicenseeChange}
                            sx={{ width: 200}}
                        >
                            {licenseeDropdown.map((licenseeItem) =>
                                <MenuItem  FreeSolo={true} value={licenseeItem.singleField} key={licenseeItem.singleField}
                                >{licenseeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField variant="filled"
                               {...register('stakeholderId', { required: false })}
                               id="stakeholderId"   name="stakeholderId"  label="Stakeholder ID" aria-describedby="stakeholderIdentry"
                               sx={{ width: 200, pr: 5 }} />
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="status">Status</InputLabel>
                        <Select
                            {...register('status', { required: false })}
                            labelId="demo-simple-select-filled-status"
                            id="status"
                            FreeSolo={true}
                            variant="filled"
                            label="status"
                            value={selectedStatus}
                            onChange={handleStatusChange}
                            sx={{ width: 200}}
                        >
                            {statusDropdown.map((statusItem) =>
                                <MenuItem  FreeSolo={true} value={statusItem.singleField} key={statusItem.singleField}
                                >{statusItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>

            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

